export default __webpack_public_path__ + "static/media/ProductMaster.aae4f865.xlsx";